import { toast, ToastOptions } from 'react-toastify';

interface ToastServiceOptions {
  autoClose?: number;
  position?: 'top-right' | 'top-center' | 'top-left' | 'bottom-right' | 'bottom-center' | 'bottom-left';
}

class ToastService {
  private defaultOptions: ToastOptions = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    // Add this to ensure the toast appears on top of other UI elements
    style: {
      zIndex: 9999
    }
  };

  private successStyle = {
    backgroundColor: "#4CAF50",
    color: "white",
    borderRadius: "8px",
    fontWeight: "500",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
  };

  private errorStyle = {
    backgroundColor: "#f44336",
    color: "white",
    borderRadius: "8px",
    fontWeight: "500",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
  };

  private warningStyle = {
    backgroundColor: "#ff9800",
    color: "white",
    borderRadius: "8px",
    fontWeight: "500",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
  };

  private infoStyle = {
    backgroundColor: "#2196f3",
    color: "white",
    borderRadius: "8px",
    fontWeight: "500",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
  };

  constructor(options?: ToastServiceOptions) {
    if (options) {
      this.defaultOptions = { ...this.defaultOptions, ...options };
    }
  }

  success(message: string, options?: ToastOptions) {
    toast.success(message, {
      ...this.defaultOptions,
      ...options,
      style: { ...this.successStyle, zIndex: 9999 }
    });
  }

  error(message: string, options?: ToastOptions) {
    toast.error(message, {
      ...this.defaultOptions,
      autoClose: 5000,
      ...options,
      style: { ...this.errorStyle, zIndex: 9999 }
    });
  }

  warning(message: string, options?: ToastOptions) {
    toast.warning(message, {
      ...this.defaultOptions,
      ...options,
      style: { ...this.warningStyle, zIndex: 9999 }
    });
  }

  info(message: string, options?: ToastOptions) {
    toast.info(message, {
      ...this.defaultOptions,
      ...options,
      style: { ...this.infoStyle, zIndex: 9999 }
    });
  }

  // Add a simple test method to check if toasts are working
  test() {
    this.success("Test success toast");
    setTimeout(() => this.error("Test error toast"), 1000);
    setTimeout(() => this.info("Test info toast"), 2000);
    setTimeout(() => this.warning("Test warning toast"), 3000);
  }
}

// Create a singleton instance for global use
const toastService = new ToastService();
export default toastService;
